import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getNotificationTemplates } from "../../api/apiNotificationTemplates";

export const useGetNotificationTemplates = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["notification-templates", params, i18next.language],
        queryFn: () => getNotificationTemplates(params),
        keepPreviousData: true,
    });

    const templates = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params?.per_page || 50, total: templates.length };

    return { templates, meta, isLoading, error, refetch };
};
